import { gql } from '@apollo/client';
import type { CustomDashboard } from '../../__generated__/graphql';
import graphQLRequester from '../../request/GraphQLRequester';
import type { GraphQLRestDataSourceError } from '../../request/Types';

export class GraphQLCustomDashboardsRequester {
  public getCustomDashboards = (): Promise<CustomDashboard[]> =>
    graphQLRequester
      .query<{
        customDashboards: CustomDashboard[];
        errors: Array<GraphQLRestDataSourceError>;
      }>({
        query: gql`
          query customDashboards {
            customDashboards {
              id
              externalDashboardId
              name
              description
              fleets {
                fleetId
                groupsRestrictions
              }
              filters {
                filterKey
                filterName
              }
            }
          }
        `,
      })
      .then((result) => {
        if (result.errors !== undefined) {
          throw result.errors[0];
        }
        return result.customDashboards;
      });

  public getCustomDashboard = (externalDashboardId: string): Promise<CustomDashboard> =>
    graphQLRequester
      .query<{
        customDashboard: CustomDashboard;
        errors: Array<GraphQLRestDataSourceError>;
      }>({
        query: gql`
          query customDashboard($input: String!) {
            customDashboard(input: $input) {
              id
              externalDashboardId
              name
              description
              fleets {
                fleetId
                groupsRestrictions
              }
              filters {
                filterName
                filterKey
              }
            }
          }
        `,
        variables: { input: externalDashboardId },
      })
      .then((result) => {
        if (result.errors !== undefined) {
          throw result.errors[0];
        }
        return result.customDashboard;
      });
}

export default GraphQLCustomDashboardsRequester;
